export default __webpack_public_path__ + "static/media/PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate14_LP_767x577.b05f9b8b.jpg";